/* eslint-disable max-len */
import React from 'react'
import Checkbox from "react-custom-checkbox";
import * as Icon from "react-icons/fi";
export default function CheckboxComponent(props){
    const {type,Filters,setfilters}=props

    const handleCheck=(type)=>{
        const arr=[...Filters.offer_type];
        const idx= Filters.offer_type.indexOf(type);
        if(idx===-1){
            arr.push(type)
        }else{
            arr.splice(idx,1)
        }
        setfilters((prevState)=>({
            ...prevState,
            offer_type:arr
        }))
    }
    return(
        <Checkbox
            icon={
                <Icon.FiCheck color="#FFFF" size={14} style={{background:`${Filters?.offer_type.includes(type) ? '#555259':''}`}} />
            }
            name="my-input"
            id={type === 'Standard' ? 'checkbox-21' :  type === "Special" ? 'checkbox-11': 'checkbox-22'}
            className="cursor-pointer"
            checked={Filters?.offer_type.includes(type)}
            onChange={()=>handleCheck(type)}
            borderColor={`${Filters?.offer_type.includes(type)?"#B8C5DC":"#555259"}`}
            style={{ cursor: "pointer" }}
            labelStyle={{ marginLeft: 5, userSelect: "none" ,cursor:'pointer'}}
        /> 
    )
}
